/** Central route path constants — single source of truth for the router,
 * nav links, and internal <Link> usage (migration plan §2.2). */
export const routes = {
  home: "/",
  undergraduate: "/UG_Scholarship",
  undergraduateStatus: "/UG_Scholarship/status",
  postgraduate: "/PG_Scholarship",
  postgraduateStatus: "/PG_Scholarship/status",
} as const
